import { useEffect, useState } from "react";

const navItems = [
  { href: "#quotes", label: "精选语录" },
  { href: "#lines", label: "治愈短句" },
  { href: "#reflections", label: "时光感悟" },
  { href: "#companion", label: "深夜陪伴" },
  { href: "#captions", label: "朋友圈配文" },
  { href: "#wall", label: "共鸣墙" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 cursor-pointer shrink-0"
          aria-label="长日光阴 首页"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-moon-clear-line text-base"></i>
          </span>
          <span className="font-heading text-lg font-semibold tracking-wide text-foreground-950">
            长日光阴
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-2">
          <a
            href="#wall"
            className="px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            写下心情
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 pb-4">
          <ul className="flex flex-col py-2">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-3 text-sm text-foreground-800 hover:bg-primary-50 rounded-md cursor-pointer"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#wall"
            onClick={() => setOpen(false)}
            className="block text-center px-4 py-3 text-sm rounded-md bg-primary-500 text-background-50 cursor-pointer"
          >
            写下心情
          </a>
        </div>
      )}
    </header>
  );
}